import { render, staticRenderFns } from "./communityView.vue?vue&type=template&id=c5937308&scoped=true"
import script from "./communityView.vue?vue&type=script&lang=js"
export * from "./communityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5937308",
  null
  
)

export default component.exports